import React, { useState } from 'react';
import { API_URL } from '../config';
import Spinner from './Spinner';

function SaveTemplateModal({ token, formSchema, onClose, onSaved }) {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSave = async () => {
    if (!name.trim()) {
      setError('Inserisci un nome per il modello');
      return;
    }

    if (!formSchema || formSchema.length === 0) {
      setError('Il modulo deve contenere almeno un campo');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_URL}/form-templates`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: name.trim(),
          schema: formSchema
        })
      });

      if (response.ok) {
        const template = await response.json();
        if (onSaved) onSaved(template);
        onClose();
      } else {
        const data = await response.json();
        setError(data.detail || 'Errore durante il salvataggio');
      }
    } catch (err) {
      setError('Errore di connessione');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && name.trim()) {
      handleSave();
    }
    if (e.key === 'Escape') {
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-2xl max-w-md w-full">
        {/* Header */}
        <div className="px-6 py-4 border-b flex items-center justify-between">
          <h2 className="text-xl font-bold text-gray-800">Salva come Modello</h2>
          <button
            onClick={onClose}
            className="p-2 text-gray-500 hover:text-gray-700 rounded-lg hover:bg-gray-100"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="px-6 py-4">
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4">
              {error}
            </div>
          )}

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Nome del modello *
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Es: Modulo Ferrate"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              autoFocus
            />
          </div>

          <p className="text-sm text-gray-500">
            Il modello conterrà {formSchema?.length || 0} camp{formSchema?.length === 1 ? 'o' : 'i'}.
            Una volta salvato, il contenuto del modello non potrà essere modificato.
          </p>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t bg-gray-50 rounded-b-lg flex gap-3">
          <button
            onClick={onClose}
            disabled={loading}
            className="flex-1 px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition font-medium disabled:opacity-50"
          >
            Annulla
          </button>
          <button
            onClick={handleSave}
            disabled={loading || !name.trim()}
            className="flex-1 px-4 py-2 text-white rounded-lg transition font-medium disabled:opacity-50 flex items-center justify-center gap-2"
            style={{ backgroundColor: loading || !name.trim() ? '#93C5FD' : '#0E60C6' }}
            onMouseEnter={(e) => !loading && name.trim() && (e.currentTarget.style.backgroundColor = '#0B4FA3')}
            onMouseLeave={(e) => !loading && name.trim() && (e.currentTarget.style.backgroundColor = '#0E60C6')}
          >
            {loading && <Spinner size="sm" color="white" />}
            {loading ? 'Salvataggio...' : 'Salva Modello'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SaveTemplateModal;
